import styled from 'styled-components';
import { Flex, InlineAlert } from '@amzn/storm-ui';

// Column layout for the control side of the FormRow: the toggle and any one-way /
// locked messaging, stacked and aligned with the form's control column so the field
// lines up with the inputs above it.
export const WaitlistControl = styled(Flex)`
  flex-direction: column;
  row-gap: 0.5rem;
  max-width: 40rem;
`;

export const WaitlistDetailAlert = styled(InlineAlert)`
  margin-top: 0.25rem;
`;

// The FormRow wraps helpTipNode inside a HelpTip whose content otherwise inherits
// the label column's narrow width and right alignment. Give the tooltip a readable
// fixed width and left-aligned, normally-sized text.
export const WaitlistHelpTipContent = styled.div`
  width: 18rem;
  text-align: left;
  font-size: 0.8125rem;
  line-height: 1.4;
  font-weight: normal;
`;
